import React, { useContext, useState } from 'react';
import { bool, string, object, number } from 'prop-types';
import { connect } from 'react-redux';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import { MachineTranslationButton } from '@fiverr-private/machine_translation';
import { fetchUGC, toggleUGCView, ugcUpdated } from '../../actions/ugc';
import { buildSourceInfo } from '../../utils/ugc/buildSourceInfo';
import SafePureComponentWrapper from '../shared/SafePureComponent';

const UGCTranslateButton = ({
    showOriginal,
    ugcMap,
    fetchUGC,
    toggleUGCView,
    ugcUpdated,
    isLeanStyle = false,
    componentName,
    gigId,
    user
}) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);
    const [loading, setLoading] = useState(false);

    const shouldRenderButton = locale !== DEFAULT_LOCALE;
    const sourceInfo = buildSourceInfo({ componentName, gigId, user });

    const toggleUgc = async() => {
        const shouldFetchTranslation = showOriginal && !ugcMap.translated;

        if (!shouldFetchTranslation) {
            toggleUGCView();
            return;
        }

        setLoading(true);
        await fetchUGC({ sourceInfo, shouldToggle: true });
        setLoading(false);
    };

    if (!shouldRenderButton) {
        return null;
    }

    const onToggle = async() => {
        await toggleUgc();
        ugcUpdated();
    };

    const { LEAN_DEFAULT, DEFAULT } = MachineTranslationButton.STYLES;
    const style = isLeanStyle ? LEAN_DEFAULT : DEFAULT;

    return (
        <section className="ugc-translation-button-wrapper">
            <MachineTranslationButton loading={loading}
                toggled={!showOriginal}
                onClick={onToggle}
                style={style}
                sourceInfo={sourceInfo}/>
        </section>
    );
};

UGCTranslateButton.propTypes = {
    showOriginal: bool,
    isLeanStyle: bool,
    componentName: string,
    gigId: number,
    user: object
};

const mapStateToProps = ({ ugc }) => ({
    ...ugc
});

const ConnectedUGCTranslateButton = connect(mapStateToProps, {
    fetchUGC,
    toggleUGCView,
    ugcUpdated
})(UGCTranslateButton);

export { ConnectedUGCTranslateButton };

export default SafePureComponentWrapper(ConnectedUGCTranslateButton);
